module.exports = __webpack_public_path__ + "public/images/main-before.cc307f6d022e5ab2c2c865ce8d20d8fd.svg";